import { Text } from '@cubeyou-team/hx-react-components';
import styled from 'styled-components';

export const StyledItemActions = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  padding: 0 ${props => props.theme.spacing.small};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  visibility: hidden;
  opacity: 0;
`;
export const StyledItem = styled.div`
  border-bottom: 2px solid ${props => props.theme.colors.light_darker_1};
  display: flex;
  align-items: center;
  position: relative;

  &:hover,
  &:active {
    background-color: ${props => props.theme.colors.light_dark};
  }

  user-select: none;

  ${StyledItemActions} {
    ${props => `visibility: ${props.isTemporary ? 'hidden' : 'visible'}`};
    opacity: 1;
    .audience-actions {
      visibility: hidden;
      opacity: 0;
    }
    .hx-repository-item__more-actions {
      visibility: hidden;
      opacity: 0;
    }
  }
  &:hover {
    ${StyledItemActions} {
      visibility: visible;
      background-color: ${props => props.theme.colors.light_dark};

      .audience-actions {
        visibility: visible;
        opacity: 1;
        z-index: 99999;
      }
      .hx-repository-item__more-actions {
        visibility: visible;
        opacity: 1;
        z-index: 99999;
      }
    }
  }

  padding: ${props => props.theme.spacing.medium} 0px
    ${props => props.theme.spacing.medium} ${props => props.theme.spacing.small};
  width: 100%;
`;

export const StyledText = styled(Text)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  cursor: text;
`;
